export default __webpack_public_path__ + "media/images/brands/xpress/backgrounds/bg-02-951e0b3a0ab311fb9ccebbebedd4cfa6.jpg";